import * as universal from '../entries/pages/events/_page.ts.js';

export const index = 3;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/events/_page.svelte.js')).default;
export { universal };
export const universal_id = "src/routes/events/+page.ts";
export const imports = ["_app/immutable/nodes/3.DWD9TtdQ.js","_app/immutable/chunks/HWquhxtj.js","_app/immutable/chunks/CWj6FrbW.js","_app/immutable/chunks/4vq2VORQ.js","_app/immutable/chunks/CtZl-tYg.js","_app/immutable/chunks/LOhPtrgM.js","_app/immutable/chunks/DDTo001e.js","_app/immutable/chunks/WMK_I3pw.js"];
export const stylesheets = ["_app/immutable/assets/theme.CD54FDqW.css","_app/immutable/assets/UpcomingEvents.DICZUGd0.css","_app/immutable/assets/2.tn0RQdqM.css"];
export const fonts = [];
